var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "884E9929-EC99-4A6D-A5C7-BCCD94E4C162") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-client-profile",
    transform: "translate(-548.000000, -361.000000)",
    fill: "#AD6A99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(16.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taxes",
    transform: "translate(432.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(33.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/performance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18103455,1.40000006 L7.5431037,1.40000006 L7.5431037,2.83564022 C9.68635913,3.11820731 11.3448278,5.03668409 11.3448278,7 C7.00000014,7 6.6050158,7 2.65517245,7 C2.65517245,5.03668403 4.31364125,3.11820719 6.45689678,2.83564019 L6.45689678,1.40000006 L6.81896559,1.40000006 L6.81896559,0 L7.18103455,0 L7.18103455,1.40000006 Z M2.83620692,8.75 L3.92241385,8.75 L3.92241385,12.5999999 L2.83620692,12.5999999 L2.83620692,8.75 Z M4.64655161,8.75 L5.73275853,8.75 L5.73275853,12.5999999 L4.64655161,12.5999999 L4.64655161,8.75 Z M6.45689678,8.75 L7.5431037,8.75 L7.5431037,12.5999999 L6.45689678,12.5999999 L6.45689678,8.75 Z M8.2672414,8.75 L9.35344832,8.75 L9.35344832,12.5999999 L8.2672414,12.5999999 L8.2672414,8.75 Z M10.077586,8.75 L11.1637929,8.75 L11.1637929,12.5999999 L10.077586,12.5999999 L10.077586,8.75 Z M2.27499999,12.9500004 L11.725,12.9500004 C12.0149495,12.9500004 12.25,13.1850509 12.25,13.4750004 C12.25,13.7649499 12.0149495,14.0000004 11.725,14.0000004 L2.27499999,14.0000004 C1.9850505,14.0000004 1.75,13.7649499 1.75,13.4750004 C1.75,13.1850509 1.9850505,12.9500004 2.27499999,12.9500004 Z M2.27499999,7.35000022 L11.725,7.35000022 C12.0149495,7.35000022 12.25,7.58505072 12.25,7.87500021 C12.25,8.16494969 12.0149495,8.40000019 11.725,8.40000019 L2.27499999,8.40000019 C1.9850505,8.40000019 1.75,8.16494969 1.75,7.87500021 C1.75,7.58505072 1.9850505,7.35000022 2.27499999,7.35000022 Z",
    id: "ic/taxes"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTax);
export default __webpack_public_path__ + "static/media/view_tax.fbfc6e9610832d144b32f01aac1d7fcc.svg";
export { ForwardRef as ReactComponent };